import { useContext } from "react";
import { OrderDetail } from "../../../../interfaces/interfaces";
import CartItemTable from "../../../../components/CartItemTable/CartItemTable";
import { Context, IContext } from "../../../../context/ContextApp";
import { getPaymentDetails, getPaymentDetailsPaid } from "../../../../utils/OrderPaymentDetails";

interface Props {
  order: OrderDetail;
}

function OrderHistoryContent({ order }: Props) {
  const { appBranch }: IContext = useContext(Context);

  const paymentDetails =
    order?.payment_status === "paid"
      ? getPaymentDetailsPaid(order, appBranch)
      : getPaymentDetails(order, appBranch);

  return (
    <div className="order-content-section">
      {order.comment && (
        <div className="ship-to-section">
          <div className="order-comment">
            <span className="comment-label">Comment:</span>
            <span className="comment-text">{order.comment}</span>
          </div>
        </div>
      )}

      <div className="order-table-wrapper">
        <CartItemTable items={order.order_items} bo split checkout />
      </div>

      <div className="order-summary-section">
        <div className="order-summary-card">
          {paymentDetails.map((paymentDetail, index) => (
            <div
              key={index}
              className={`summary-row ${paymentDetail.boldTitle ? "summary-row--total" : ""}`}
            >
              <span className="summary-label">{paymentDetail.title}:</span>
              <span className="summary-value">{paymentDetail.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OrderHistoryContent;
